export default __webpack_public_path__ + "static/features-image-3-c41b4375fc33764f8cc8a58a4b161e8a.png";